
import { Component, Vue } from "vue-property-decorator";
import Swal from "sweetalert2";
import { Getter } from "vuex-class";
import User from "@/models/User";
import GlobalConfig from "@/GlobalConfig";

@Component({})
export default class Encuesta extends Vue {
  @Getter("user") user!: User;

  loading: boolean = true;
  iframeSrc: string = "";
  redirectTo: string = "";

  mounted() {
    this.loading = true;
    this.showLoadingAlert("Cargando...");

    const numeroSolicitud = this.$route.query.numeroSolicitud as string;
    this.redirectTo = this.$route.query.redirectTo as string;
    let formUrl = GlobalConfig.FORMSTACK_BASE_SURVEY_URL;
    const params = new URLSearchParams({
      embedded: "true",
      cedula: this.user.cedula,
      numeroSolicitud: numeroSolicitud
    });

    this.iframeSrc = `${formUrl}?${params.toString()}`;

    setTimeout(() => {
      this.loading = false;
      Swal.close();
    }, 2000);

    window.addEventListener("message", this.handleIframeSubmit);
  }

  beforeDestroy() {
    window.removeEventListener("message", this.handleIframeSubmit);
  }

  handleIframeSubmit(event: MessageEvent) {
    const allowedOrigin = "https://afpsiembra.formstack.com";
    if (event.origin === allowedOrigin && typeof event.data === "string") {
        this.showsAlert();
      
    }
  }

  public showLoadingAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });
  }
  public showsAlert(): void {
    Swal.fire({
      text:
        "Valoramos tu tiempo. Espera unos segundos mientras te redireccionamos al resumen de tu solicitud",
      title: "¡Gracias por tu respuesta!",
      icon: "success",
      showConfirmButton: false,
      timer: 5000,
      onClose: () => {
        this.$router.push("/");
      },
    });
  }
}
